import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { FeatureFlagKey } from "@stw/feature-flags";

import { useFeatureFlag } from "~frontend/providers/LoggedInUserProvider/context";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";

/**
 * Hook to redirect to a given path if a feature flag is disabled.
 * @param flag Key of the feature flag in question
 * @param redirectPath Path to redirect to if the flag is disabled. Will apply subaccount link to path before redirecting.
 */
export function useFlagRedirect(
  flag: FeatureFlagKey,
  redirectPath: string
): void {
  const isEnabled = useFeatureFlag(flag);
  const navigate = useNavigate();
  const subaccount = useSubaccount();

  useEffect(() => {
    if (subaccount && !isEnabled) {
      void navigate(subaccount.subaccountLink(redirectPath));
    }
  }, [isEnabled, navigate, redirectPath, subaccount]);
}
